<template>
  <b-card body-class="p-0" header-class="border-0">
    <template v-slot:header>
      <b-row align-v="center">
        <b-col>
          <h3 class="mb-0">Resumen de Paralizaciones</h3>
        </b-col>
        <b-col class="text-right">
          <!-- Botón para alternar la visibilidad de la tabla -->
          <base-button @click="mostrarTabla = !mostrarTabla" size="sm" type="primary">
            {{ mostrarTabla ? 'Ocultar -' : 'Mostrar +' }}
          </base-button>
        </b-col>
      </b-row>
    </template>

<el-table
  v-if="mostrarTabla"
  :data="datosAgrupados"
  class="table-responsive"
  style="width: 100%"
  row-key="jornada">
  <el-table-column
    type="expand">
    <template #default="props">
      <!-- Contenido del detalle, mostrado cuando la fila se expande -->
              <el-table
          :data="props.row.detalles"
          style="width: 100%; "
          default-sort="{prop: 'bodega', order: 'ascending'}">
          <el-table-column
            prop="bodega"
            label="Bodega"
            sortable
            :sort-method="ordenarBodega">
            <template #default="props">
              <strong>{{ props.row.bodega }}</strong>
            </template>
          </el-table-column>
          <el-table-column prop="motivo" label="Motivo"></el-table-column>
          <el-table-column prop="minutos" label="Duración" :formatter="formatoDuracion"></el-table-column>
        </el-table>

    </template>
  </el-table-column>
  
  <!-- Columnas principales de la tabla -->
  <el-table-column prop="jornada" label="Jornada">
  <template #default="props">
    <span :style="{ color: obtenerColorJornada(props.row.jornada) }"><b>{{ props.row.jornada }}</b></span>
  </template>
</el-table-column>
  <el-table-column label="Duración Total">
  <template #default="props">
    {{ formatoDuracion(props.row, null, props.row.totalMinutos) }}
  </template>
</el-table-column>

</el-table>

  </b-card>
</template>


<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import moment from 'moment'

export default {
  name: 'paralizaciones',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    listaJornada: {
      type: Array,
      default: () => [],
    },
    listaDatosData: {
      type: Array,
      default: () => [],
    },
    listaParalizacion: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mostrarTabla: true, // Controla la visibilidad de la tabla
      coloresJornada: [
      "rgba(0, 77, 107, 1)", // #004D6B
      "rgba(0, 139, 139, 1)", // #008B8B
      // "rgba(255, 175, 29, 1)", // #FFAF1D
      // "rgba(255, 104, 0, 1)", // #FF6800
    ],
    opacidadActual: 1, // Opacidad inicial completa
  };
  },
  methods:{

    ordenarBodega(a, b) {
  // Extrae el número después de "BODEGA N° " y conviértelo a un número
  const regex = /^BODEGA N° (\d+)$/;
  const matchA = a.bodega.match(regex);
  const matchB = b.bodega.match(regex);

  let numeroA = matchA ? parseInt(matchA[1], 10) : Infinity; // Usa Infinity para cualquier cosa que no coincida
  let numeroB = matchB ? parseInt(matchB[1], 10) : Infinity; // Esto asegura que cualquier no coincidencia va al final

  // Si ambos números son iguales (ambos Infinity o iguales), compara por bodega directamente para mantener un orden consistente
  if (numeroA === numeroB) {
    return a.bodega.localeCompare(b.bodega);
  }

  // Compara los números para ordenar
  return numeroA - numeroB;
},


    agruparPorJornadas() {
    const resultado = this.datosTabla.reduce((acumulador, itemActual) => {
      // Buscar si ya existe una entrada para la jornada actual
      let entradaJornada = acumulador.find(entrada => entrada.jornada === itemActual.idJornada);
      
      if (!entradaJornada) {
        // Si no existe, crear una nueva entrada para la jornada
        entradaJornada = {
          jornada: itemActual.idJornada,
          totalMinutos: 0,
          detalles: [],
          mostrarDetalles: false, // Añadir esta línea para controlar la visibilidad

        };
        acumulador.push(entradaJornada);
      }
      
      // Añadir los minutos al total de la jornada
      entradaJornada.totalMinutos += itemActual.totalMinutos;
      
      // Añadir el detalle de la paralización actual
      entradaJornada.detalles.push({
        bodega: itemActual.idDistProductos,
        motivo: itemActual.motivo,
        minutos: itemActual.totalMinutos,
      });
      
      return acumulador;
    }, []);

    return resultado;
  },



    obtenerColorJornada(idJornada) {
    // Convertir idJornada a un valor numérico simple para usar como índice
    let hash = 0;
    for (let i = 0; i < idJornada.length; i++) {
      hash = idJornada.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colorIndex = Math.abs(hash) % this.coloresJornada.length; // Usa el valor absoluto para evitar índices negativos
    return this.coloresJornada[colorIndex];
  },

          agruparParalizaciones() {
          return this.listaParalizacion.reduce((acc, item) => {
            // Clave única para la agrupación
            const clave = `${item.ID_JORNADA}|${item.ID_DIST_PRODUCTOS}|${item.MOTIVO}`;
            if (!acc[clave]) {
              acc[clave] = [];
            }
            acc[clave].push(item);
            return acc;
          }, {});
        },

        calcularDuracionSinSuperposicion(items) {
            // Asumiendo que items está ordenado por hora de inicio
            let totalMinutos = 0;
            let ultimoFin = null;

            items.forEach(item => {
              const inicio = moment(item.INICIO, 'DD/MM/YYYY HH:mm:ss');
              const fin = moment(item.FIN, 'DD/MM/YYYY HH:mm:ss');

              if (!ultimoFin || inicio.isAfter(ultimoFin)) {
                totalMinutos += fin.diff(inicio, 'minutes');
                ultimoFin = fin;
              } else if (fin.isAfter(ultimoFin)) {
                totalMinutos += fin.diff(ultimoFin, 'minutes');
                ultimoFin = fin;
              }
            });

            return totalMinutos;
          },


          formatoDuracion(row, column, value) {
    const horas = Math.floor(value / 60);
    const minutos = value % 60;
    if (horas > 0) {
      return `${horas}h ${minutos}min`; // Devuelve horas y minutos si hay al menos 1 hora
    } else {
      return `${minutos}min`; // Solo devuelve minutos si no hay horas
    }
  },
   
      Jornada(idproductophite) {
        let res = this.Paralist.filter(val => {
          return val.BETAJORNADAMOTIVO === idproductophite;
        });

        // Devuelve solo el primer elemento coincidente
        return res.length > 0 ? res[0].ID_JORNADA : '';
      },

      Motivo(idproductophite) {
        let res = this.Paralist.filter(val => {
          return val.BETAJORNADAMOTIVO === idproductophite;
        });

        // Devuelve solo el primer elemento coincidente
        return res.length > 0 ? res[0].MOTIVO : '';
      },


      Minutos(idproductophite) {
              let totalMinutos = 0;
              let res = this.Paralist.filter(val => val.BETAJORNADAMOTIVO == idproductophite);

              res.forEach(element => {
                totalMinutos += element.MINUTOS;
              });

              // Convertir minutos a horas y minutos
              const horas = Math.floor(totalMinutos / 60);
              const minutos = totalMinutos % 60;

              // Devuelve el tiempo en formato 'X horas Y minutos' si hay horas, o solo 'Y minutos' si no hay horas
              return horas > 0 ? `${horas} h ${minutos} min` : `${minutos} min`;
            },

      DiferenciaJornadaPhite(idproductophite) {
        let res =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })
        

        res.forEach(element => {
         element.FECHA_FIN_CARGIO
        });

        let beta =  this.DataCompleta.filter(val => {
            return val.JORNADA == idproductophite;
        })
        

        beta.forEach(element => {
         element.FECHA_INICIO_CARGUIO
        });

        var date2 = moment(beta[beta.length -1].FECHA_FIN_CARGIO, 'DD-MM-YYYY HH:mm').format('MM-DD-YYYY HH:mm');
        var date1 = moment(res[0].FECHA_INICIO_CARGUIO, 'DD-MM-YYYY HH:mm').format('MM-DD-YYYY HH:mm');
        // var diff = date2.diff(date1, 'minutes');        

        var now = moment(date1),
        end = moment(date2),
        minutes = end.diff(now, 'Minutes');

        return minutes/60

      },

  },
  computed: {

    datosAgrupados() {
    return this.agruparPorJornadas();
  },

    datosTabla() {
    const agrupados = this.agruparParalizaciones();
    return Object.keys(agrupados).map(clave => {
      const [idJornada, idDistProductos, motivoBase] = clave.split('|');

      // Encuentra el nombre de la jornada usando ID_JORNADA
      const jornadaObj = this.listaJornada.find(j => j.ID === idJornada);
      const nombreJornada = jornadaObj ? jornadaObj.JORNADA : 'Nombre no encontrado';

      // Preparar el motivo incluyendo la observación si es necesario
      const items = agrupados[clave];
      let motivo = motivoBase; // Inicialmente, el motivo es el base

      // Si el motivo es "OTROS", añade la observación (en mayúsculas)
      if (motivoBase === 'OTROS') {
        // Nota: Suponiendo que todas las observaciones en un grupo son iguales, toma la primera
        const observacion = items[0].OBSERVACION ? ` (${items[0].OBSERVACION.toUpperCase()})` : '';
        motivo += observacion;
      }

      const totalMinutos = this.calcularDuracionSinSuperposicion(items.sort((a, b) => moment(a.INICIO, 'DD/MM/YYYY HH:mm:ss').diff(moment(b.INICIO, 'DD/MM/YYYY HH:mm:ss'))));

      // Retorna los datos incluyendo el nombre de la jornada y el motivo ajustado
      return { 
        idJornada: nombreJornada, // Usa el nombre en lugar del ID
        idDistProductos, 
        motivo, // Usa el motivo ajustado para incluir la observación
        totalMinutos 
      };
    }).filter(({ totalMinutos }) => totalMinutos > 0); // Opcional: Filtra entradas con duración total de 0 minutos
  },
  
    // JornadaFiltrada() {
    //   return this.JornadaUnica.filter(row => this.ViajesBalanza(row) > 0);
    // },
    

    // mapaColoresJornada() {
    //   const colores = [
    //     "rgba(0, 28, 38, 1)", // #001C26
    //     "rgba(0, 77, 107, 1)", // #004D6B
    //     "rgba(190, 219, 225, 1)", // #BEDBE1
    //     "rgba(0, 139, 139, 1)", // #008B8B
    //     "rgba(255, 175, 29, 1)", // #FFAF1D
    //     "rgba(255, 104, 0, 1)", // #FF6800
    //   ];
    //   const mapa = {};
    //   this.JornadaUnica.forEach((jornada, index) => {
    //     // Asigna el color, reciclando con diferentes opacidades si es necesario
    //     const colorBase = colores[index % colores.length];
    //     const opacidad = 1 - (Math.floor(index / colores.length) * 0.1);
    //     const color = colorBase.replace(/1\)$/, `${Math.max(opacidad, 0.1)})`); // Asegura una opacidad mínima de 0.1
    //     mapa[jornada] = color;
    //   });
    //   return mapa;
    // },

    JornadaUnica() {
      let jornada = [
        ...new Set(this.Paralist.map((productlist) => productlist.BETAJORNADAMOTIVO)),
      ];
      return jornada;
    },

    Paralist() {
  return this.listaParalizacion.map((item) => {
    const inicio = moment(item.INICIO, 'DD/MM/YYYY HH:mm:ss');
    const fin = moment(item.FIN, 'DD/MM/YYYY HH:mm:ss');

    // Calcula la diferencia en minutos
    const diferenciaEnMinutos = fin.diff(inicio, 'minutes');

    // Buscar la JORNADA correspondiente en listaJornada
    const jornadaCorrespondiente = this.listaJornada.find(jornada => jornada.ID === item.ID_JORNADA);
    const idJornada = jornadaCorrespondiente ? jornadaCorrespondiente.JORNADA : item.ID_JORNADA;

    // Convertir MOTIVO a mayúsculas y añadir OBSERVACION si es necesario
    let motivo = item.MOTIVO.toUpperCase();
    if (item.OBSERVACION && item.OBSERVACION !== "0") {
      motivo += ` (${item.OBSERVACION.toUpperCase()})`;
    }
    const betaJornadaMotivo = `${idJornada} / ${motivo}`;

    return {
      BETAJORNADAMOTIVO: betaJornadaMotivo,
      ID_JORNADA: idJornada,
      ID_DIST_PRODUCTOS: item.ID_DIST_PRODUCTOS,
      MOTIVO: motivo,
      INICIO: item.INICIO,
      FIN: item.FIN,
      MINUTOS: diferenciaEnMinutos,
      OBSERVACION: item.OBSERVACION
    };
  });
},







    DataCompleta() {
      return this.listaDatosData.map((item) => {
  
        return {
          
          PESO_NETO_PUERTO: this.convertir(item.PESO_NETO_PUERTO),
          ID_PRODUCTO: item.ID_PRODUCTO,
          ID_DIST_PRODCUTO_ALM: item.ID_DIST_PRODCUTO_ALM,
          FECHA_INICIO_CARGUIO: item.FECHA_INICIO_CARGUIO,
          FECHA_FIN_CARGIO: item.FECHA_FIN_CARGIO,
          JORNADA: item.JORNADA
          // PUERTO: item.ID_NAVES+'_'+item.CLIENTE
        };
            }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        }).filter(function( element ) {
          return element.ID_PRODUCTO !== undefined;
        })
              },



  },
};
</script>

<style scoped>
.el-table__expanded-cell[class*=cell] {
    padding: 20px 50px !important;
}
</style>
